<div class="pr-small rounded-large border mr-small-b white-bg">
  <ng-container *ngIf="isCompleted$ | async; else notCompleted">
    <div class="dn-mobile db-tablet-up">
      <div class="flex">
        <fcom-icon
          class="icon-large nordic-blue-900-text mr-medium-r"
          [name]="SvgLibraryIcon.CHECKMARK_BUTTON_SELECTED"
        ></fcom-icon>
        <div>
          <h2 class="font-body-1 nordic-blue-900-text mr-xsmall-b">
            {{ 'MMB.apis.globalStatus.complete.title' | finLocalization }}
          </h2>
          <p class="font-body-1 ms-xsmall-b">
            {{ 'MMB.apis.globalStatus.complete.description' | finLocalization }}
          </p>
        </div>
      </div>
    </div>
    <div class="db-mobile dn-mobile-up">
      <div class="full align-center">
        <fcom-icon
          class="icon-xxlarge nordic-blue-900-text mr-medium-b"
          [name]="SvgLibraryIcon.CHECKMARK_BUTTON_SELECTED"
        ></fcom-icon>
      </div>
      <h2 class="font-body-1 nordic-blue-900-text mr-xsmall-b">
        {{ 'MMB.apis.globalStatus.complete.title' | finLocalization }}
      </h2>
      <p class="font-body-1 ms-xsmall-b">
        {{ 'MMB.apis.globalStatus.complete.description' | finLocalization }}
      </p>
    </div>
  </ng-container>
  <ng-template #notCompleted>
    <h2 class="font-body-1 nordic-blue-900-text mr-xsmall-b">
      {{ 'MMB.apis.globalStatus.notComplete.title' | finLocalization }}
    </h2>
    <p class="font-body-1 ms-xsmall-b">
      {{ 'MMB.apis.globalStatus.notComplete.description' | finLocalization }}
    </p>
    <div *ngFor="let travelRequirement of travelRequirements$ | async">
      <fin-apis-status-row
        [completed]="travelRequirement.status === FinnairCompletionStatus.COMPLETED"
        [translationKey]="'MMB.apis.passenger.' + travelRequirement.name"
      ></fin-apis-status-row>
    </div>
  </ng-template>
</div>
